import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onDiscard: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export function ConfirmUnsavedDialog(props: Props) {
  const { t } = useTranslation();

  function handleClose() {
    props.onCancel();
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
      <DialogTitle>
        <Typography variant="h2">{t("label.youHaveUnsavedChanges")}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>{t("label.unsavedChangesDescription")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => props.onCancel()}>
          {t("label.cancel")}
        </Button>
        <Button autoFocus onClick={() => props.onDiscard()} color="secondary">
          {t("label.discardChanges")}
        </Button>
        <Button autoFocus onClick={() => props.onSave()} color="primary">
          {t("label.saveChanges")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
